import script from "./OverviewListDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewListDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewListDetailPage.vue?vue&type=style&index=0&id=3b3a5517&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3a5517"]])

export default __exports__